import { getFeature } from 'Cloud/Application/FeaturesEs6';

const defaultHiddenConfig = {
    // tempexp_19379-start
    trialOnboarding: false,
    cleanerOnboarding: false,
    // tempexp_19379-end
    // tempexp_19378-next-line
    trial1tbBannerPromo: false,

    // tempexp_19377-start
    disableAdButton: {
        mainPage: false,
        public: false,
        viewer: false,
        worm: false,
    },
    // tempexp_19377-end
};

// Фича для выключения для оверквотеров различных частей Облака
export const hideOverquotaFeatures: typeof defaultHiddenConfig = getFeature('cloud-hide-overquota-features') || defaultHiddenConfig;
